"use strict";
/**
 * 延时港股相关页面
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageDelayHK = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var quotetable_1 = require("../quotetable");
var hotlinks_1 = require("../quotetable/hotlinks");
var react_router_dom_1 = require("react-router-dom");
var qihuotable_1 = require("../qihuotable");
var delay_qihuo = [
    '#futures_hkex',
    '#hk_index_futures',
    '#hk_stock_futures',
    '#hcf_cus',
    '#hmfs_lrp',
];
/**
 * 港股(带延时市场的包括期货)
 * @returns
 */
function PageDelayHK() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLocaleLowerCase();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        hash == '#ah_comparison' && react_1.default.createElement(hotlinks_1.SZ_HKHotLinks, null),
        delay_qihuo.indexOf(hash) < 0 && react_1.default.createElement(quotetable_1.QuoteTable, null),
        delay_qihuo.indexOf(hash) > -1 && react_1.default.createElement(qihuotable_1.QiHuoTable, null)));
}
exports.PageDelayHK = PageDelayHK;
